const getDaysUntil = (deliveryDate: string) => {
  const currentDate = Date.now();
  const dayInMillis = 24 * 60 * 60 * 1000;
  return Math.ceil((new Date(deliveryDate).getTime() - currentDate) / dayInMillis);
};

export default getDaysUntil;
